module.exports = __webpack_public_path__ + "static/media/fall.64f82f2f.jpg";